module.exports = __webpack_public_path__ + "img/airport-bar.7a9a0790.png";